import EarningsChart from "../Earning/EarningsChart";
import Queries from "../../queries/queries2";
import React from "react";
import ReportingContainer from "../Reporting/ReportingContainer";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

class EarningsContainer extends ReportingContainer {
  render() {
    return (
      <ReportingContainer
        {...this.props}
        type={"EARNINGS"}
        // header={"ids_earnings"}
        header={"ids_reports"}
        query={Queries.getEarningsReportData}
        Chart={EarningsChart}
        hideBudgetTypeSelect={true}
        hideReportsTypeSelect={false}
      />
    );
  }
}

export default withRouter(injectIntl(EarningsContainer));
